import styles from '@ui/components/Card/components/CardAction/CardAction.module.scss';
import React, { cloneElement } from 'react';
import classNames from 'classnames';

const CardAction = ({ children, className }) => (
  <>
    {cloneElement(children, {
      className: classNames(styles.container, className),
    })}
  </>
);

export default CardAction;
